import { UserPrompt, ManagedPrompt } from "./web-api"

export type AnyPrompt = UserPrompt | ManagedPrompt

export function isUserPrompt(prompt: AnyPrompt): prompt is UserPrompt {
  return "propelAuthUserID" in prompt
}

export function isManagedPrompt(prompt: AnyPrompt): prompt is ManagedPrompt {
  return !isUserPrompt(prompt)
}
